import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, FormGroup, FormControl } from 'react-bootstrap';
import { Bubble, UploadInstructions, DeleteButton, DownloadButton } from 'ctia-ui';
import InputFile from 'components/form/InputFile';
import SupportDocsReadonly from 'components/SupportDocsReadonly';
import {
  handleDocTitleChange,
  handleDocFileChange,
  documentDownload,
  deleteDocument,
  fetchRequest
} from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';
import { hasSupDocs } from 'helpers/RequestHelper';
import { cutFileExtension } from 'helpers/StringHelper';

class SupportDocs extends Component {
  onDelete = slot => {
    const { deleteDocument, request, fetchRequest } = this.props;
    return deleteDocument(request.id, slot).then(() =>
      fetchRequest(request.id)
    );
  };

  onSelectFile = (index, event) => {
    const { handleDocFileChange, handleDocTitleChange, request } = this.props;

    // set file description as file name by default (w/o file extension)
    const fileName = cutFileExtension(event.target.files[0].name);

    // create event for changing description action manually
    const titleChangeEvent = { id: 'supportDocs', target: { value: fileName } };

    handleDocFileChange(index, request.supportDocs, event);
    handleDocTitleChange(index, request.supportDocs, titleChangeEvent);
  };

  render() {
    const { user, request } = this.props;
    const { supportDocs } = request;

    // show just links for download in this mode
    if (!user.canUploadRequestDocs) {
      return <SupportDocsReadonly docs={supportDocs} />;
    }

    const isDisabled = !user.canEditRequest && !user.canUploadRequestDocs;
    const showActions = hasSupDocs(request);

    return (
      <div>
        <Bubble show={true}>
          If you have supporting documentation you would like to provide with
          this request, please name the documents and upload them here.
        </Bubble>
        <Table striped condensed hover>
          <thead>
            <tr>
              <th>Document Title</th>
              <th>Select Document</th>
              {showActions && <th className="action-column-width">Action</th>}
            </tr>
          </thead>
          <tbody>
            {supportDocs.map((item, i) => {
              return (
                <tr key={i}>
                  <td>
                    <FormGroup bsSize="small">
                      <FormControl
                        name="supportDocs"
                        type="text"
                        onChange={this.props.handleDocTitleChange.bind(
                          this,
                          i,
                          supportDocs
                        )}
                        value={item.title}
                        disabled={isDisabled}
                      />
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <InputFile
                        id={`supFile${i}`}
                        name="supportDocs"
                        onChange={this.onSelectFile.bind(this, i)}
                        disabled={isDisabled}
                        file={item.file}
                      />
                    </FormGroup>
                  </td>
                  {showActions && (
                    <td>
                      {item.docId > 0 && user.canUploadRequestDocs && (
                        <DeleteButton
                          size="small"
                          action={this.onDelete.bind(this, item.slot)}
                        />
                      )}
                      {item.docId > 0 && (
                        <DownloadButton
                          size="small"
                          action={this.props.documentDownload.bind(
                            this,
                            item,
                            request
                          )}
                        />
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
        {user.canUploadRequestDocs && <UploadInstructions />}
      </div>
    );
  }
}

SupportDocs.propTypes = {
  readonly: PropTypes.bool
};

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    handleDocTitleChange,
    handleDocFileChange,
    documentDownload,
    deleteDocument,
    startPreloader,
    finishPreloader,
    fetchRequest,
    showNotice
  }
)(SupportDocs);



// WEBPACK FOOTER //
// ./src/components/SupportDocs.js